import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./donationcancel.css";

const DonationCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("cancel_handled") === "true") {
      navigate("/checkout", { replace: true });
      return;
    }

    // Clean up query parameters (?success=false&donationId=...) from browser URL bar
    if (window.location.search) {
      navigate("/cancel", { replace: true });
    }
  }, [navigate]);

  const handleNavigate = (path) => {
    sessionStorage.setItem("cancel_handled", "true");
    navigate(path, { replace: true });
  };

  return (
    <>
      <Helmet>
        <title>Donation Cancelled | Fund Life</title>
        <meta
          name="description"
          content="Your donation process was cancelled. No charges were made. You can try again anytime to support our mission."
        />
      </Helmet>

      <div className="donation-cancel-container">
        <div className="donation-cancel-card">
          <div className="donation-cancel-icon-wrapper">
            <img
              src="/miniLogo.png"
              alt="Fund Life Logo"
              className="donation-cancel-icon"
            />
          </div>

          <h1 className="donation-cancel-title">Donation Cancelled</h1>

          <p className="donation-cancel-subtitle">
            Your transaction was not completed and no payment was processed.
          </p>

          <div className="donation-cancel-banner-box">
            <img
              src="/lovesmarter.png"
              alt="Love Smarter Not Harder Book"
              className="donation-cancel-book-img"
            />
            <div className="donation-cancel-banner-text">
              <h4>Every Book Shapes a Future</h4>
              <p>
                Your support puts relationship intelligence books directly into
                the hands of college students.
              </p>
            </div>
          </div>

          <div className="donation-cancel-actions">
            <button
              onClick={() => handleNavigate("/checkout")}
              className="btn-primary-cancel"
            >
              <i className="bi bi-arrow-repeat"></i> Try Again / Sponsor Books
            </button>
            <button
              onClick={() => handleNavigate("/")}
              className="btn-secondary-cancel"
            >
              Return to Home
            </button>
          </div>

          <div className="donation-cancel-help">
            Having trouble completing your donation?{" "}
            <button
              onClick={() => handleNavigate("/contactus")}
              className="donation-cancel-support-btn"
            >
              Contact Support
            </button>{" "}
            or email us at{" "}
            <a href="mailto:support@fundlife.me">support@fundlife.me</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default DonationCancel;
